var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltipTail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 10,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.768 1c.77-1.333 2.694-1.333 3.464 0l3.464 6c.77 1.333-.192 3-1.732 3H2.036C.496 10-.466 8.333.304 7l3.464-6Z",
  fill: "#31363A"
})));
export default SvgTooltipTail;